"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const datasetContext = (0, react_1.createContext)({
    jsonDataByCategory: [],
    jsonDataByIdList: [],
    jsonDataCategory: "",
    getJsonDataByCategory: {},
    getJsonDataByIdList: {},
    removeDatasetData: {},
});
exports.default = datasetContext;
